// Import model
import { DataviewProposalLineResponse } from '../models/DataviewProposalLineResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProposalLineRequest } from '../models/FilterProposalLineRequest';
import { ProposalLine } from '../models/ProposalLine';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProposalLineRequestSerializer } from './FilterProposalLineRequestSerializer';
import { ProposalLineSerializer } from './ProposalLineSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProposalLineResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProposalLineResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProposalLineResponse instance
   */
  static deserialize(json: string): DataviewProposalLineResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProposalLineResponse instance
   */
  static fromObject(obj: any): DataviewProposalLineResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProposalLineResponse');
    }


    const instance: DataviewProposalLineResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProposalLineSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProposalLineRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProposalLineResponse instances
   */
  static deserializeArray(json: string): DataviewProposalLineResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProposalLineResponse instance to a JSON string
   */
  static serialize(instance: DataviewProposalLineResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProposalLineResponse instance to a plain object
   */
  static toObject(instance: DataviewProposalLineResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProposalLineSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProposalLineRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProposalLineResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProposalLineResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
